import { FileSpreadsheet, Landmark, UserRound } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import {
  AgentCore,
  ConnectionLines,
  GraphicCard,
  IllustrationFrame,
  StackedCard,
  VerifiedPill,
} from './shared'

function Spreadsheet() {
  return (
    <g>
      <StackedCard x={44} y={49} width={192} height={188} />
      <FileSpreadsheet x="60" y="64" width="20" height="20" className="text-primary-strong" />
      <text x="90" y="79" className="fill-foreground text-xs font-semibold">
        XLSX / CSV
      </text>
      <rect x="60" y="99" width="160" height="26" rx="4" className="fill-primary/10" />
      <rect x="60" y="159" width="160" height="28" rx="4" className="fill-primary/5" />
      <path
        d="M60 130H220 M60 158H220 M60 186H220 M60 214H220 M112 99V214 M168 99V214"
        className="stroke-border"
      />
      {[112, 144, 172, 200].map(y => (
        <path
          key={y}
          d={`M70 ${y}H100 M124 ${y}H156 M180 ${y}H208`}
          className="stroke-muted-foreground/30"
          strokeWidth="3"
          strokeLinecap="round"
        />
      ))}
    </g>
  )
}

export function StructuredIngestIllustration() {
  const { t } = useTranslation()
  const key = 'whatsNew.slides.structuredIngest.graphic'
  return (
    <IllustrationFrame label={t(`${key}.description`)}>
      <ConnectionLines d="M236 145H285 M351 145H386Q402 145 402 128V79H437 M402 128V177H437 M524 108V148" />
      <Spreadsheet />
      <AgentCore label={t(`${key}.mapping`)} />
      <GraphicCard
        card={{ x: 437, y: 50, label: t('schemaAgent.intro.graphic.person'), icon: UserRound }}
      />
      <GraphicCard
        card={{ x: 437, y: 148, label: t('schemaAgent.intro.graphic.account'), icon: Landmark }}
      />
      <text x="536" y="131" className="fill-muted-foreground text-3xs">
        {t(`${key}.transfers`)}
      </text>
      <circle cx="402" cy="128" r="4" className="fill-primary" />
      <VerifiedPill label={t(`${key}.approved`)} />
    </IllustrationFrame>
  )
}
